var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page login",class:`${_vm.$store.state.ie.sigla}`},[_c('header',{staticClass:"header"},[_c('Logo',{attrs:{"maxwidth":"235px"}})],1),_c('div',{staticClass:"section"},[_c('router-view',{key:_vm.$route.path})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }